// extracted by mini-css-extract-plugin
export default {"facebookIcon":"Wd_l1D"};